<div class="card-header">
  <app-ordered-header-list
    minWidth="1120px"
    [headerItems]="headerItems"
    (orderChangeEvent)="orderChange($event)"
  >
    <ng-container headerFlag>
      <div class="" style="width:20px;text-align:left">#</div>
      <div class="flex-1">
        <div class="box-select">
          <app-c-checkbox
            #checkbox
            [checked]="checkAll"
            [id]="'all-contracts'"
            [controlDisabled]="contracts.length === 0"
            [indeterminate]="isHeaderIndeterminate"
            (change)="changeHeaderCheckbox($event)"
          ></app-c-checkbox>
        </div>
      </div>
    </ng-container>
    <ng-container buttonSpace><div class="w-24 h-24"></div></ng-container
  ></app-ordered-header-list>
</div>
<ng-container *ngFor="let contract of contracts; let i = index">
  <app-card-manual-batch-contract [contract]="contract" [linha]="i+1">
    <ng-container cardFlag>
      <app-c-checkbox
        #checkbox
        [checked]="checkContract(contract.ContractId)"
        [id]="contract.ContractId"
        (change)="changeCardCheckbox($event, contract)"
      ></app-c-checkbox>
    </ng-container>
  </app-card-manual-batch-contract>
</ng-container>
<ng-container *ngIf="contracts.length === 0">
  <div class="vw-100 pt-10">
    <app-empty-card
      text="Não há nenhum contrato"
      minWidth="1120px"
    ></app-empty-card>
  </div>
</ng-container>
<ng-content select="[footer]"></ng-content>
